// @ts-nocheck
/* eslint-disable no-alert, no-console, react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { 
  ShieldCheck, 
  Search, 
  Filter, 
  Building2, 
  CheckCircle,
  Clock,
  FileText,
  ChevronRight,
  ChevronLeft,
  Receipt,
  DollarSign,
  Eye,
  X,
  CreditCard,
  Loader2,
  FileDown,
  AlertTriangle,
  Ban,
  Check,
  CheckSquare,
  Square,
  Send,
  Layers,
  ExternalLink
} from "lucide-react";
import { collection, query, onSnapshot, doc, updateDoc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from "../../config/firebase";

const AdminGarantiasAtivasPage = () => {
  const [garantias, setGarantias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [imobiliariaFilter, setImobiliariaFilter] = useState("Todas");
  const [imobiliariasList, setImobiliariasList] = useState([]);
  
  // States de Paginação (Tabela Principal)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  // States do Modal de Fechamento B2B
  const [isModalFechamentoOpen, setIsModalFechamentoOpen] = useState(false);
  const [modalSearchTerm, setModalSearchTerm] = useState(""); 
  const [isProcessingBoleto, setIsProcessingBoleto] = useState(null);
  
  // States de Paginação (Modal Fechamento)
  const [currentModalPage, setCurrentModalPage] = useState(1);
  const modalItemsPerPage = 5; 

  // States de Seleção em Lote (B2B)
  const [selectedModalImobs, setSelectedModalImobs] = useState([]);
  const [isProcessingLote, setIsProcessingLote] = useState(false);
  
  // 🟢 ESTADO DO RESET DO MÊS
  const [isResetting, setIsResetting] = useState(false);

  // 🟢 ESTADOS DO NOVO MODAL DE ENCERRAMENTO (BLOCO 4)
  const [isModalDocsEncerramentoOpen, setIsModalDocsEncerramentoOpen] = useState(false);
  const [garantiaParaDocs, setGarantiaParaDocs] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "contratos_ativos"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const garantiasData = [];
      const imobs = new Set();

      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        if (data.status !== "Contrato Encerrado") {
          garantiasData.push({ id: docSnap.id, ...data });
          if (data.companyName) {
            imobs.add(data.companyName);
          }
        }
      });

      garantiasData.sort((a, b) => {
        const dateA = a.dataAtivacao?.toMillis() || 0;
        const dateB = b.dataAtivacao?.toMillis() || 0;
        return dateB - dateA;
      });

      setGarantias(garantiasData);
      setImobiliariasList(Array.from(imobs).sort());
      setLoading(false);
    }, (error) => {
      console.error("Erro ao buscar garantias:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Reseta as páginas sempre que um filtro é aplicado
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, imobiliariaFilter]);

  useEffect(() => {
    setCurrentModalPage(1);
  }, [modalSearchTerm]);

  const handleFinalizarContrato = async (garantia) => {
    const confirmar = window.confirm(
      `CONFIRMAÇÃO DE AUDITORIA:\n\nVocê está homologando o encerramento definitivo do protocolo ${garantia.protocoloOrigem}.\n\nIsso atualizará a Dashboard e moverá o contrato para o histórico. Confirma?`
    );

    if (!confirmar) return;

    try {
      const contratoRef = doc(db, "contratos_ativos", garantia.id);
      await updateDoc(contratoRef, {
        status: "Contrato Encerrado",
        dataEncerramentoDefinitivo: serverTimestamp(),
        encerramentoSolicitado: false 
      });

      const requestRef = doc(db, "requests", garantia.id);
      const requestSnap = await getDoc(requestRef);

      if (requestSnap.exists()) {
        await updateDoc(requestRef, {
          status: "Contrato Encerrado",
          updatedAt: serverTimestamp() 
        });
      }

      alert("Contrato encerrado e Dashboard atualizada com sucesso.");
    } catch (err) {
      console.error("Erro ao processar a auditoria do contrato:", err);
      alert("Erro ao processar a auditoria. Verifique o console.");
    }
  };

  // Trava de Scroll Global
  useEffect(() => {
    if (isModalFechamentoOpen || isModalDocsEncerramentoOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => { document.body.style.overflow = "unset"; };
  }, [isModalFechamentoOpen, isModalDocsEncerramentoOpen]);

  const handleCloseModal = () => {
    setIsModalFechamentoOpen(false);
    setModalSearchTerm(""); 
    setCurrentModalPage(1);
    setSelectedModalImobs([]);
  };

  // ============================================================================
  // LÓGICA DO MODAL DE AUDITORIA DE ENCERRAMENTO (INTEGRAÇÃO STORAGE)
  // ============================================================================
  const handleAbrirDocsEncerramento = (garantia) => {
    setGarantiaParaDocs(garantia);
    setIsModalDocsEncerramentoOpen(true);
  };

  const handleFecharDocsEncerramento = () => {
    setIsModalDocsEncerramentoOpen(false);
    setGarantiaParaDocs(null);
  };

  const handleAbrirTodosDocsEncerramento = () => {
    const docs = garantiaParaDocs?.documentosEncerramento;
    if (!docs) return;

    const urlBoleto = typeof docs.boletoComprovante === 'object' ? docs.boletoComprovante?.url : null;
    const urlRecibo = typeof docs.reciboChaves === 'object' ? docs.reciboChaves?.url : null;

    if (!urlBoleto && !urlRecibo) {
      alert("Os links reais dos documentos ainda não estão disponíveis neste contrato.");
      return;
    }

    alert("Dica: Os navegadores bloqueiam a abertura de múltiplas abas ao mesmo tempo. Caso os documentos não abram, verifique o bloqueador de pop-ups na sua barra de endereços e clique em 'Sempre permitir'.");
    
    if (urlBoleto) window.open(urlBoleto, '_blank');
    if (urlRecibo) {
      setTimeout(() => {
        window.open(urlRecibo, '_blank');
      }, 500);
    }
  };

  // ============================================================================
  // FILTROS E PAGINAÇÃO CLIENT-SIDE (TABELA PRINCIPAL)
  // ============================================================================
  const garantiasFiltradas = garantias.filter(g => {
    const searchLower = searchTerm.toLowerCase();
    const matchesSearch = 
      g.protocoloOrigem?.toLowerCase().includes(searchLower) ||
      g.pagador?.nome?.toLowerCase().includes(searchLower) ||
      g.pagador?.cpf?.includes(searchTerm);
      
    const matchesImob = imobiliariaFilter === "Todas" || g.companyName === imobiliariaFilter;

    return matchesSearch && matchesImob;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = garantiasFiltradas.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(garantiasFiltradas.length / itemsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  const valorTotalMensal = garantiasFiltradas.reduce((acc, curr) => {
    if (curr.idEncerramentoSolicitado || curr.idEncerramentoSolicitado === true || curr.encerramentoSolicitado) return acc;
    const taxa = parseFloat(curr.faturamento?.valorTaxa?.replace(/\./g, '').replace(',', '.') || 0);
    return acc + taxa;
  }, 0);

  const aguardandoRepasseQtd = garantiasFiltradas.filter(g => 
    g.ciclo?.statusRepasse === "Aguardando Fechamento" && !g.encerramentoSolicitado
  ).length;

  const encerramentoPendenteQtd = garantiasFiltradas.filter(g => g.idEncerramentoSolicitado || g.idEncerramentoSolicitado === true || g.encerramentoSolicitado).length;

  // ============================================================================
  // EXPORTAÇÃO DE RELATÓRIO / PDF
  // ============================================================================
  const handleExportarPDF = () => {
    const dataAtual = new Date().toLocaleDateString('pt-BR');
    const filtroAplicado = imobiliariaFilter === "Todas" ? "Visão Global" : imobiliariaFilter;
    
    const linhasTabela = garantiasFiltradas.map(g => `
      <tr>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-size: 12px;">${g.protocoloOrigem || 'N/A'}</td>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-size: 12px;">${g.companyName || 'N/A'}</td>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-size: 12px;">${g.pagador?.nome || 'N/A'}<br><small style="color: #666;">${g.pagador?.cpf || ''}</small></td>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-size: 12px; font-weight: bold;">R$ ${g.faturamento?.valorTaxa || '0,00'}</td>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-size: 12px;">${g.encerramentoSolicitado ? 'SOLICITADO ENCERRAMENTO' : (g.ciclo?.statusRepasse || 'Não Definido')}</td>
      </tr>
    `).join('');

    const printWindow = window.open('', '', 'height=800,width=1000');
    
    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Relatório de Fechamento - ${filtroAplicado}</title>
            <style>
              body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #333; padding: 20px; }
              .header { border-bottom: 2px solid #0d9488; padding-bottom: 10px; margin-bottom: 20px; }
              .header h1 { margin: 0; color: #0f172a; font-size: 24px; }
              .header p { margin: 5px 0 0 0; color: #64748b; font-size: 14px; }
              .summary { display: flex; justify-content: space-between; background: #f8fafc; padding: 15px; border-radius: 8px; margin-bottom: 20px; border: 1px solid #e2e8f0; }
              .summary-box strong { display: block; font-size: 12px; color: #64748b; text-transform: uppercase; }
              .summary-box span { font-size: 18px; font-weight: bold; color: #0f172a; }
              table { width: 100%; border-collapse: collapse; margin-top: 10px; }
              th { background-color: #f1f5f9; padding: 10px 8px; text-align: left; font-size: 13px; color: #475569; border-bottom: 2px solid #cbd5e1; }
              @media print {
                body { -webkit-print-color-adjust: exact; padding: 0; }
                button { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h1>Relatório de Fechamento - Real Benefícios</h1>
              <p>Data de Emissão: ${dataAtual} | Filtro: ${filtroAplicado}</p>
            </div>
            
            <div class="summary">
              <div class="summary-box">
                <strong>Total de Contratos</strong>
                <span>${garantiasFiltradas.length}</span>
              </div>
              <div class="summary-box">
                <strong>Aguardando Repasse</strong>
                <span>${aguardandoRepasseQtd}</span>
              </div>
              <div class="summary-box">
                <strong>Valor Total Estimado</strong>
                <span>R$ ${valorTotalMensal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
              </div>
            </div>

            <table>
              <thead>
                <tr>
                  <th>Protocolo</th>
                  <th>Imobiliária</th>
                  <th>Locatário (Pagador)</th>
                  <th>Valor da Taxa</th>
                  <th>Status do Repasse</th>
                </tr>
              </thead>
              <tbody>
                ${linhasTabela}
              </tbody>
            </table>
            <script>
              window.onload = function() { window.print(); window.close(); }
            </script>
          </body>
        </html>
      `);
      
      printWindow.document.close();
    }
  };

  // ============================================================================
  // MOTOR DE CONSOLIDAÇÃO (FECHAMENTO MENSAL) E PAGINAÇÃO DO MODAL
  // ============================================================================
  const consolidarFechamento = () => {
    const agrupado = garantias.reduce((acc, curr) => {
      // 🔒 FILTRO CORRIGIDO: Ignora os contratos se a forma for diferente de "Boleto Imobiliária"
      if (
        curr.ciclo?.statusRepasse !== "Aguardando Fechamento" || 
        curr.faturamento?.formaPagamento !== "Boleto Imobiliária" ||
        curr.idEncerramentoSolicitado || 
        curr.idEncerramentoSolicitado === true || 
        curr.encerramentoSolicitado
      ) return acc;
      
      const compName = curr.companyName || "Desconhecida";
      const compId = curr.companyId || "sem_id";
      const taxa = parseFloat(curr.faturamento?.valorTaxa?.replace(/\./g, '').replace(',', '.') || 0);

      if (!acc[compName]) {
        acc[compName] = { companyId: compId, total: 0, count: 0, contratosIds: [] };
      }
      
      acc[compName].total += taxa;
      acc[compName].count += 1;
      acc[compName].contratosIds.push(curr.id);
      
      return acc;
    }, {});

    return Object.entries(agrupado).map(([nomeImob, dados]) => ({
      nome: nomeImob,
      ...dados
    }));
  };

  const listaFechamentoBruta = consolidarFechamento();
  const listaFechamentoFiltrada = listaFechamentoBruta.filter(imob => 
    imob.nome.toLowerCase().includes(modalSearchTerm.toLowerCase())
  );
  
  const indexOfLastModalItem = currentModalPage * modalItemsPerPage;
  const indexOfFirstModalItem = indexOfLastModalItem - modalItemsPerPage;
  const currentModalItems = listaFechamentoFiltrada.slice(indexOfFirstModalItem, indexOfLastModalItem);
  const totalModalPages = Math.ceil(listaFechamentoFiltrada.length / modalItemsPerPage);

  const nextModalPage = () => {
    if (currentModalPage < totalModalPages) setCurrentModalPage(prev => prev + 1);
  };

  const prevModalPage = () => {
    if (currentModalPage > 1) setCurrentModalPage(prev => prev - 1);
  };

  const totalGeralModal = listaFechamentoFiltrada.reduce((acc, curr) => acc + curr.total, 0);

  // ============================================================================
  // ⚡ LÓGICA DE SELEÇÃO EM LOTE DO MODAL
  // ============================================================================
  const isAllModalSelected = listaFechamentoFiltrada.length > 0 && selectedModalImobs.length === listaFechamentoFiltrada.length;

  const handleToggleModalSelectAll = () => {
    if (isAllModalSelected) {
      setSelectedModalImobs([]);
    } else {
      setSelectedModalImobs(listaFechamentoFiltrada.map(i => i.companyId));
    }
  };

  const handleToggleModalSelect = (companyId) => {
    setSelectedModalImobs(prev => 
      prev.includes(companyId) ? prev.filter(id => id !== companyId) : [...prev, companyId]
    );
  };

  const getCurrentEnv = () => {
    const currentDomain = window.location.hostname;
    return process.env.REACT_APP_ENV || (currentDomain.includes('homolog') || currentDomain.includes('localhost') ? 'homolog' : 'production');
  };

  // ============================================================================
  // ⚡ GATILHO B2B: VIRADA DO MÊS (RESET DE CICLO)
  // ============================================================================
  const handleResetMensal = async () => {
    const confirmar = window.confirm("ATENÇÃO: Você está prestes a iniciar a Virada do Mês.\n\nIsso fará com que todos os contratos faturados voltem para o status 'Aguardando Fechamento' preparando o painel para o novo ciclo.\n\nConfirma o reset?");
    if (!confirmar) return;

    setIsResetting(true);
    const activeEnv = getCurrentEnv(); 
    const functions = getFunctions();
    const virarCiclo = httpsCallable(functions, 'virarCicloFaturamentoB2B');

    try {
      await virarCiclo({ environment: activeEnv }); 
      alert("✅ Virada de mês concluída com sucesso! Os contratos foram resetados e o painel está pronto para o novo ciclo.");
    } catch (error) {
      console.error("Erro ao resetar o mês:", error);
      alert("Erro ao realizar a virada do mês. Verifique sua conexão e tente novamente.");
    } finally {
      setIsResetting(false);
    }
  };

  // ============================================================================
  // ⚡ GATILHO B2B: GERAÇÃO DE BOLETO DE REPASSE (MOTOR BACKEND)
  // ============================================================================
  const handleEmitirBoletosEmLote = async () => {
    if (selectedModalImobs.length === 0) return;

    const confirmar = window.confirm(`ATENÇÃO: Você está iniciando a Virada do Mês B2B.\n\nDeseja disparar o fechamento no Asaas para ${selectedModalImobs.length} imobiliária(s) selecionada(s)?`);
    if (!confirmar) return;

    setIsProcessingLote(true);
    const activeEnv = getCurrentEnv();
    const functions = getFunctions();
    
    // 🔒 CONEXÃO BLINDADA: Chama o motor que nós auditamos no Backend!
    const processarFechamento = httpsCallable(functions, 'processarFechamentoManualB2B');

    try {
      await processarFechamento({
        imobiliariasIds: selectedModalImobs,
        environment: activeEnv
      });
      
      alert(`✅ Lote B2B Processado com Sucesso!\nOs boletos foram gerados pelo sistema financeiro e as imobiliárias já estão com o status "Repasse Cobrado".`);
      
      // Limpa os estados e fecha o modal
      setSelectedModalImobs([]);
      handleCloseModal();
      
    } catch (error) {
      console.error("Erro ao gerar lotes B2B via Backend:", error);
      alert("Ocorreu um erro ao processar o fechamento B2B. Verifique sua conexão e tente novamente.");
    } finally {
      setIsProcessingLote(false);
    }
  };

  const handleGerarBoletoImobiliaria = async (imob) => {
    setSelectedModalImobs([imob.companyId]);
    setTimeout(() => {
       document.getElementById('btn-disparo-lote')?.click();
    }, 100);
  };

  const mockWebhookPagamentoAsaas = async (contratoId) => {
    const confirmar = window.confirm("MOCK: Deseja simular o pagamento deste boleto pelo Asaas?");
    if (!confirmar) return;

    try {
      const ref = doc(db, "contratos_ativos", contratoId);
      await updateDoc(ref, {
        "ciclo.statusRepasse": "Repasse Pago",
        "ciclo.dataPagamentoRepasse": serverTimestamp()
      });
      alert("Sucesso! O sistema registrou o pagamento (Mock).");
    } catch (err) {
      console.error(err);
      alert("Erro ao simular pagamento.");
    }
  };

  // ============================================================================
  // SKELETON LOADER
  // ============================================================================
  if (loading) {
    return (
      <div className="relative z-0 p-4 sm:p-5 xl:p-8 space-y-5 xl:space-y-6 bg-slate-50 min-h-full font-sans w-full animate-pulse">
        <div className="h-8 bg-slate-200 rounded w-48 mb-2"></div>
        <div className="h-4 bg-slate-200 rounded w-96 mb-6"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 xl:gap-6">
          {Array(4).fill(0).map((_, i) => (
            <div key={i} className="bg-white p-5 xl:p-6 rounded-2xl border border-slate-200 h-28 flex items-start justify-between">
              <div className="space-y-3 w-full">
                <div className="h-3 bg-slate-200 rounded w-1/2"></div>
                <div className="h-8 bg-slate-200 rounded w-1/3"></div>
              </div>
              <div className="w-10 h-10 rounded-full bg-slate-100 shrink-0"></div>
            </div>
          ))}
        </div>

        <div className="bg-white p-4 xl:p-5 rounded-2xl border border-slate-200 h-20"></div>

        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
          <div className="bg-slate-50 border-b border-slate-200 h-12"></div>
          {Array(5).fill(0).map((_, i) => (
            <div key={i} className="flex justify-between items-center p-4 border-b border-slate-100">
              <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-24"></div><div className="h-3 bg-slate-100 rounded w-16"></div></div>
              <div className="h-4 bg-slate-200 rounded w-32 hidden md:block"></div>
              <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-28"></div><div className="h-3 bg-slate-100 rounded w-20"></div></div>
              <div className="h-6 bg-slate-200 rounded w-24 hidden md:block"></div>
              <div className="h-8 bg-slate-200 rounded w-8"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="relative z-0 p-4 sm:p-5 xl:p-8 space-y-5 xl:space-y-6 animate-fade-in bg-slate-50 min-h-full font-sans w-full">
      
      {/* BREADCRUMB & HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <div className="flex items-center text-sm text-slate-500 font-medium mb-1">
            <Link to="/super-admin" className="hover:text-brand-primary transition-colors">Dashboard</Link>
            <ChevronRight className="w-4 h-4 mx-1" />
            <span className="text-slate-800 font-semibold">Garantias Ativas</span>
          </div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <ShieldCheck className="w-7 h-7 text-brand-primary" />
            Gestão de Carteira Ativa
          </h1>
          <p className="text-slate-500 text-sm mt-1">Acompanhe os contratos vigentes e gerencie os repasses (Asaas).</p>
        </div>

        <div className="flex items-center gap-3">
          <button 
            onClick={handleExportarPDF}
            className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors font-semibold text-sm shadow-sm"
          >
            <FileDown className="w-4 h-4" /> Exportar PDF
          </button>
          
          {/* 🟢 BOTÃO DA OPÇÃO 1: RESET DO MÊS */}
          <button
            onClick={handleResetMensal}
            disabled={isResetting}
            className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-colors font-semibold text-sm shadow-md disabled:opacity-50 border border-transparent"
          >
            {isResetting ? <Loader2 className="w-4 h-4 animate-spin text-white" /> : <Layers className="w-4 h-4 text-white" />}
            <span className="text-white">Iniciar Novo Mês</span>
          </button>

          <button 
            onClick={() => setIsModalFechamentoOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-brand-primary text-white rounded-xl hover:bg-teal-600 transition-colors font-semibold text-sm shadow-md"
          >
            <Receipt className="w-4 h-4" /> Fechamento Mensal
          </button>
        </div>
      </div>

      {/* CARDS DE RESUMO */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 xl:gap-6">
        <div className="bg-white p-5 xl:p-6 rounded-2xl border border-slate-200 shadow-sm flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500">Contratos Ativos</p>
            <h3 className="text-2xl xl:text-3xl font-bold text-slate-800 mt-1">{garantiasFiltradas.filter(g => g.status !== "Contrato Encerrado").length}</h3>
          </div>
          <div className="w-10 h-10 xl:w-12 xl:h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center">
            <FileText className="w-5 h-5 xl:w-6 xl:h-6" />
          </div>
        </div>

        <div className="bg-white p-5 xl:p-6 rounded-2xl border border-slate-200 shadow-sm flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500">Receita Mensal Estimada</p>
            <h3 className="text-2xl xl:text-3xl font-bold text-slate-800 mt-1">
              R$ {valorTotalMensal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </h3>
          </div>
          <div className="w-10 h-10 xl:w-12 xl:h-12 rounded-full bg-green-50 text-green-600 flex items-center justify-center">
            <DollarSign className="w-5 h-5 xl:w-6 xl:h-6" />
          </div>
        </div>

        <div className="bg-white p-5 xl:p-6 rounded-2xl border border-slate-200 shadow-sm flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500">Aguardando Repasse</p>
            <h3 className="text-2xl xl:text-3xl font-bold text-slate-800 mt-1">{aguardandoRepasseQtd}</h3>
          </div>
          <div className="w-10 h-10 xl:w-12 xl:h-12 rounded-full bg-yellow-50 text-yellow-600 flex items-center justify-center">
            <Clock className="w-5 h-5 xl:w-6 xl:h-6" />
          </div>
        </div>

        <div className={`p-5 xl:p-6 rounded-2xl border shadow-sm flex items-start justify-between transition-colors ${encerramentoPendenteQtd > 0 ? 'bg-red-50 border-red-200' : 'bg-white border-slate-200'}`}>
          <div>
            <p className={`text-sm font-medium ${encerramentoPendenteQtd > 0 ? 'text-red-600' : 'text-slate-500'}`}>Encerramentos Pendentes</p>
            <h3 className={`text-2xl xl:text-3xl font-bold mt-1 ${encerramentoPendenteQtd > 0 ? 'text-red-700' : 'text-slate-800'}`}>{encerramentoPendenteQtd}</h3>
          </div>
          <div className={`w-10 h-10 xl:w-12 xl:h-12 rounded-full flex items-center justify-center ${encerramentoPendenteQtd > 0 ? 'bg-red-100 text-red-600' : 'bg-slate-50 text-slate-400'}`}>
            <Ban className="w-5 h-5 xl:w-6 xl:h-6" />
          </div>
        </div>
      </div>

      {/* BARRA DE FILTROS E PESQUISA */}
      <div className="bg-white p-4 xl:p-5 rounded-2xl border border-slate-200 shadow-sm flex flex-col md:flex-row gap-4 justify-between items-center">
        <div className="relative w-full md:max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="w-4 h-4 text-slate-400" />
          </div>
          <input 
            type="text"
            placeholder="Buscar por protocolo, inquilino ou CPF..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-4 py-2 xl:py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary"
          />
        </div>

        <div className="flex items-center gap-3 w-full md:w-auto">
          <div className="flex items-center gap-2 text-sm font-medium text-slate-600 bg-slate-50 px-3 py-2 xl:py-2.5 rounded-xl border border-slate-200">
            <Filter className="w-4 h-4" />
            <select 
              value={imobiliariaFilter}
              onChange={(e) => setImobiliariaFilter(e.target.value)}
              className="bg-transparent focus:outline-none cursor-pointer max-w-[200px] truncate"
            >
              <option value="Todas">Todas as Imobiliárias</option>
              {imobiliariasList.map(imob => (
                <option key={imob} value={imob}>{imob}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* TABELA DE GARANTIAS */}
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
        <div className="overflow-x-auto custom-scrollbar flex-1">
          <table className="w-full text-left text-sm whitespace-nowrap">
            <thead className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold">
              <tr>
                <th className="px-4 py-3 xl:px-6 xl:py-4">Protocolo / Data</th>
                <th className="px-4 py-3 xl:px-6 xl:py-4">Imobiliária</th>
                <th className="px-4 py-3 xl:px-6 xl:py-4">Locatário Pagador</th>
                <th className="px-4 py-3 xl:px-6 xl:py-4">Valor do Serviço</th>
                <th className="px-4 py-3 xl:px-6 xl:py-4">Status de Repasse</th>
                <th className="px-4 py-3 xl:px-6 xl:py-4 text-right">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-10 text-center text-slate-500">
                    <div className="flex flex-col items-center justify-center">
                      <ShieldCheck className="w-10 h-10 text-slate-300 mb-2" />
                      <p className="font-medium text-base">Nenhuma garantia ativa encontrada na página atual.</p>
                      <p className="text-sm mt-1">Ajuste os filtros ou aprove novas solicitações.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                currentItems.map((garantia) => (
                  <tr key={garantia.id} className={`transition-colors group ${garantia.status === "Contrato Encerrado" ? 'bg-red-50/50' : garantia.idEncerramentoSolicitado || garantia.idEncerramentoSolicitado === true || garantia.encerramentoSolicitado ? 'bg-red-50/30' : 'hover:bg-slate-50'}`}>
                    <td className="px-4 py-3 xl:px-6 xl:py-4">
                      <p className="font-bold text-slate-800">{garantia.protocoloOrigem}</p>
                      <p className="text-xs text-slate-500 mt-0.5">
                        {garantia.dataAtivacao ? new Date(garantia.dataAtivacao.toDate()).toLocaleDateString('pt-BR') : "N/A"}
                      </p>
                    </td>
                    <td className="px-4 py-3 xl:px-6 xl:py-4">
                      <div className="flex items-center gap-2">
                        <Building2 className="w-4 h-4 text-slate-400 shrink-0" />
                        <span className="font-medium text-slate-700 max-w-[180px] xl:max-w-[250px] truncate" title={garantia.companyName}>
                          {garantia.companyName}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-3 xl:px-6 xl:py-4">
                      <p className="font-semibold text-slate-800 truncate max-w-[180px] xl:max-w-[250px]" title={garantia.pagador?.nome}>
                        {garantia.pagador?.nome || "Não informado"}
                      </p>
                      <p className="text-xs text-slate-500 mt-0.5">CPF: {garantia.pagador?.cpf || "N/A"}</p>
                    </td>
                    <td className="px-4 py-3 xl:px-6 xl:py-4">
                      <p className="font-bold text-slate-800">
                        R$ {garantia.faturamento?.valorTaxa || "0,00"}
                      </p>
                      <span className="inline-block mt-1 px-2 py-0.5 bg-slate-100 text-slate-600 text-[10px] font-bold rounded uppercase">
                        {garantia.faturamento?.formaPagamento || "Não definida"}
                      </span>
                    </td>
                    
                    {/* 🟢 TRAVA DE MAQUIAGEM VISUAL: STATUS "À VISTA" X MENSALIDADE */}
                    <td className="px-4 py-3 xl:px-6 xl:py-4">
                      {garantia.faturamento?.formaPagamento?.toUpperCase() === 'À VISTA' || garantia.faturamento?.formaPagamento?.toUpperCase() === 'A VISTA' ? (
                        <div className="flex items-center gap-1.5 text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-lg border border-emerald-200 font-semibold text-xs w-max">
                          <CheckCircle className="w-3.5 h-3.5" /> Pago à vista
                        </div>
                      ) : garantia.idEncerramentoSolicitado || garantia.idEncerramentoSolicitado === true || garantia.encerramentoSolicitado ? (
                        <div className="flex items-center gap-1.5 text-red-700 bg-red-100 px-2.5 py-1 rounded-lg border border-red-200 font-bold text-xs w-max animate-pulse">
                          <AlertTriangle className="w-3.5 h-3.5" /> Encerramento Solicitado
                        </div>
                      ) : (
                        <>
                          {garantia.ciclo?.statusRepasse === 'Aguardando Fechamento' && (
                            <div className="flex items-center gap-1.5 text-yellow-700 bg-yellow-50 px-2.5 py-1 rounded-lg border border-yellow-200 font-semibold text-xs w-max">
                              <Clock className="w-3.5 h-3.5" /> Aguardando Fechamento
                            </div>
                          )}
                          {(garantia.ciclo?.statusRepasse === 'Repasse Cobrado' || garantia.ciclo?.statusRepasse === 'Aguardando Pagamento') && (
                            <div className="flex items-center gap-2">
                              <div className="flex items-center gap-1.5 text-blue-700 bg-blue-50 px-2.5 py-1 rounded-lg border border-blue-200 font-semibold text-xs w-max">
                                <Receipt className="w-3.5 h-3.5" /> Faturado (Pendente)
                              </div>
                              <button 
                                onClick={() => mockWebhookPagamentoAsaas(garantia.id)}
                                className="bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded hover:bg-slate-700 transition-colors uppercase"
                                title="Simular disparo de Webhook de Pagamento do Asaas"
                              >
                                Mock Pagamento
                              </button>
                            </div>
                          )}
                          {garantia.ciclo?.statusRepasse === 'Repasse Pago' && (
                            <div className="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1 rounded-lg border border-green-200 font-semibold text-xs w-max">
                              <CheckCircle className="w-3.5 h-3.5" /> Repasse Pago (NF Liberada)
                            </div>
                          )}
                          {garantia.ciclo?.statusRepasse === 'NF Emitida' && (
                            <div className="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1 rounded-lg border border-green-200 font-semibold text-xs w-max">
                              <CheckCircle className="w-3.5 h-3.5" /> Pagamento Concluído (NF Emitida)
                            </div>
                          )}
                        </>
                      )}
                    </td>
                    <td className="px-4 py-3 xl:px-6 xl:py-4 text-right">
                      <div className="flex items-center justify-end gap-2">
                        {/* 🟢 BLOCO 4: BOTÕES DE AUDITORIA DE ENCERRAMENTO */}
                        {(garantia.idEncerramentoSolicitado || garantia.idEncerramentoSolicitado === true || garantia.encerramentoSolicitado) && (
                          <div className="flex items-center gap-2">
                            <button 
                              onClick={() => handleAbrirDocsEncerramento(garantia)}
                              className="inline-flex items-center justify-center p-2 text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-colors shadow-sm"
                              title="Validar Documentos de Encerramento"
                            >
                              <FileText className="w-5 h-5" />
                            </button>
                            <button 
                              onClick={() => handleFinalizarContrato(garantia)}
                              className="inline-flex items-center justify-center p-2 text-emerald-600 hover:text-emerald-700 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded-lg transition-colors shadow-sm"
                              title="Homologar Encerramento Definitivo"
                            >
                              <Check className="w-5 h-5" />
                            </button>
                          </div>
                        )}
                        
                        <Link 
                          to={`/super-admin/request/${(garantia.protocoloOrigem || garantia.protocolo || "").replace(/\//g, '-')}`}
                          className="inline-flex items-center justify-center p-2 text-slate-400 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors"
                          title="Ver Ficha Original"
                        >
                          <Eye className="w-5 h-5" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {garantiasFiltradas.length > 0 && (
          <div className="px-4 py-3 xl:px-6 xl:py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between shrink-0">
            <span className="text-sm text-slate-500 font-medium">
              Mostrando <span className="font-bold text-slate-800">{indexOfFirstItem + 1}</span> a <span className="font-bold text-slate-800">{Math.min(indexOfLastItem, garantiasFiltradas.length)}</span> de <span className="font-bold text-slate-800">{garantiasFiltradas.length}</span> contratos
            </span>
            <div className="flex items-center gap-2">
              <button 
                onClick={prevPage}
                disabled={currentPage === 1}
                className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                {currentPage} / {totalPages || 1}
              </span>
              <button 
                onClick={nextPage}
                disabled={currentPage >= totalPages}
                className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 🟢 MODAL: DOSSIÊ DE ENCERRAMENTO COM INTEGRAÇÃO STORAGE (BLOCO 4) */}
      {isModalDocsEncerramentoOpen && garantiaParaDocs && createPortal(
        <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 sm:p-6 animate-fade-in">
           <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={handleFecharDocsEncerramento}></div>
           <div className="relative bg-white w-full max-w-2xl rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-slate-200">
              <div className="p-6 border-b border-slate-200 flex justify-between items-start sm:items-center bg-white shrink-0">
                <div>
                  <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-brand-primary shrink-0"/> Dossiê de Encerramento
                  </h2>
                  <p className="text-sm text-slate-500 font-medium mt-1">Protocolo: {garantiaParaDocs.protocoloOrigem}</p>
                </div>
                <button onClick={handleFecharDocsEncerramento} className="p-2 bg-slate-50 hover:bg-slate-100 rounded-full text-slate-400 hover:text-slate-600 transition-colors">
                  <X className="w-5 h-5"/>
                </button>
              </div>
              
              <div className="p-6 bg-slate-50 space-y-4">
                <div className="bg-amber-50 border border-amber-200 text-amber-800 text-sm p-4 rounded-xl font-medium">
                  Revise os documentos enviados pela imobiliária antes de homologar a extinção da garantia.
                </div>

                {/* Boleto + Comprovante */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border border-slate-200 rounded-xl bg-white shadow-sm gap-4">
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm text-slate-800 truncate">
                      {typeof garantiaParaDocs.documentosEncerramento?.boletoComprovante === 'string' 
                        ? garantiaParaDocs.documentosEncerramento.boletoComprovante 
                        : garantiaParaDocs.documentosEncerramento?.boletoComprovante?.nome || "Boleto e Comprovante.pdf"}
                    </p>
                    <span className="inline-block mt-1.5 px-2 py-1 bg-slate-100 text-[10px] font-bold text-slate-500 rounded uppercase border border-slate-200">Boleto + Comprovante</span>
                  </div>
                  {typeof garantiaParaDocs.documentosEncerramento?.boletoComprovante === 'object' && garantiaParaDocs.documentosEncerramento?.boletoComprovante?.url ? (
                    <a href={garantiaParaDocs.documentosEncerramento.boletoComprovante.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-2 bg-brand-primary/10 text-brand-primary hover:bg-brand-primary hover:text-white rounded-lg transition-colors font-semibold text-sm w-full sm:w-auto justify-center">
                      Visualizar <ExternalLink className="w-4 h-4"/>
                    </a>
                  ) : (
                    <button disabled className="flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-400 rounded-lg transition-colors font-semibold text-sm w-full sm:w-auto justify-center cursor-not-allowed">
                      Indisponível
                    </button>
                  )}
                </div>

                {/* Recibo de Chaves */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border border-slate-200 rounded-xl bg-white shadow-sm gap-4">
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm text-slate-800 truncate">
                      {typeof garantiaParaDocs.documentosEncerramento?.reciboChaves === 'string' 
                        ? garantiaParaDocs.documentosEncerramento.reciboChaves 
                        : garantiaParaDocs.documentosEncerramento?.reciboChaves?.nome || "Recibo_Chaves.pdf"}
                    </p>
                    <span className="inline-block mt-1.5 px-2 py-1 bg-slate-100 text-[10px] font-bold text-slate-500 rounded uppercase border border-slate-200">Recibo de Chaves</span>
                  </div>
                  {typeof garantiaParaDocs.documentosEncerramento?.reciboChaves === 'object' && garantiaParaDocs.documentosEncerramento?.reciboChaves?.url ? (
                    <a href={garantiaParaDocs.documentosEncerramento.reciboChaves.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-2 bg-brand-primary/10 text-brand-primary hover:bg-brand-primary hover:text-white rounded-lg transition-colors font-semibold text-sm w-full sm:w-auto justify-center">
                      Visualizar <ExternalLink className="w-4 h-4"/>
                    </a>
                  ) : (
                    <button disabled className="flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-400 rounded-lg transition-colors font-semibold text-sm w-full sm:w-auto justify-center cursor-not-allowed">
                      Indisponível
                    </button>
                  )}
                </div>
              </div>

              <div className="p-6 border-t border-slate-200 bg-white flex justify-between items-center shrink-0">
                <button 
                  onClick={handleAbrirTodosDocsEncerramento}
                  className="px-4 py-2.5 text-sm font-semibold text-teal-700 bg-teal-50 border border-teal-200 hover:bg-teal-100 rounded-full flex items-center gap-2 transition-colors shadow-sm"
                >
                  <Layers className="w-4 h-4"/> Abrir todos de uma única vez
                </button>
                <button onClick={handleFecharDocsEncerramento} className="px-6 py-2.5 text-sm font-semibold bg-slate-100 text-slate-600 hover:bg-slate-200 rounded-full transition-colors border border-slate-200 shadow-sm">
                  Fechar
                </button>
              </div>
           </div>
        </div>
      , document.body)}

      {/* MODAL DE FECHAMENTO MENSAL B2B */}
      {isModalFechamentoOpen && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 xl:p-8 animate-fade-in overflow-hidden">
          <div className="absolute inset-0 bg-slate-900 bg-opacity-80 backdrop-blur-sm" onClick={handleCloseModal}></div>
          
          <div className="relative bg-white w-full max-w-5xl flex flex-col rounded-2xl shadow-2xl border border-slate-200 max-h-full overflow-hidden">
            
            <div className="p-4 xl:p-6 border-b border-slate-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-slate-50 shrink-0">
              <div className="flex items-center justify-between w-full md:w-auto">
                <div>
                  <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <Receipt className="w-5 h-5 text-brand-primary"/> Consolidar Fechamento (B2B)
                  </h2>
                  <p className="text-sm text-slate-500 font-medium mt-1">Gere repasses individuais ou em lote.</p>
                </div>
                <button onClick={handleCloseModal} className="md:hidden text-slate-400 hover:text-slate-600 p-1.5 bg-white border border-slate-200 rounded-full transition-colors">
                  <X className="w-5 h-5"/>
                </button>
              </div>

              {/* BARRA DE CONTROLE EM LOTE */}
              <div className="flex items-center gap-4 w-full md:w-auto bg-white p-2 rounded-xl border border-slate-200 shadow-sm">
                <div className="text-sm font-medium text-slate-500 px-2 whitespace-nowrap">
                  <span className="font-bold text-brand-primary">{selectedModalImobs.length}</span> selecionada(s)
                </div>
                <button 
                  id="btn-disparo-lote"
                  onClick={handleEmitirBoletosEmLote}
                  disabled={selectedModalImobs.length === 0 || isProcessingLote}
                  className="w-full md:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-brand-primary text-white hover:bg-teal-600 rounded-lg transition-colors font-bold text-sm shadow-sm disabled:opacity-50"
                >
                  {isProcessingLote ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                  Cobrar Selecionadas
                </button>
                <button onClick={handleCloseModal} className="hidden md:block text-slate-400 hover:text-slate-600 p-1.5 border border-slate-200 rounded-full transition-colors ml-2">
                  <X className="w-5 h-5"/>
                </button>
              </div>
            </div>

            <div className="p-4 xl:p-5 border-b border-slate-100 bg-white shrink-0 flex flex-col md:flex-row gap-4 justify-between items-center">
              <div className="relative w-full md:max-w-md">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Search className="w-4 h-4 text-slate-400" />
                </div>
                <input 
                  type="text"
                  placeholder="Buscar imobiliária..."
                  value={modalSearchTerm}
                  onChange={(e) => setModalSearchTerm(e.target.value)}
                  className="w-full pl-9 pr-4 py-2 xl:py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary transition-colors"
                />
              </div>
              <div className="flex flex-wrap items-center gap-4 text-sm w-full md:w-auto justify-between md:justify-end">
                <div className="text-slate-500 font-medium bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-100">
                   Imobiliárias: <span className="font-bold text-slate-800">{listaFechamentoFiltrada.length}</span>
                </div>
                <div className="text-slate-500 font-medium bg-teal-50 px-3 py-1.5 rounded-lg border border-teal-100">
                   Total Geral: <span className="font-bold text-brand-primary">R$ {totalGeralModal.toLocaleString('pt-BR', {minimumFractionDigits: 2})}</span>
                </div>
              </div>
            </div>

            {/* BARRA DE CABEÇALHO DA LISTA (SELECIONAR TUDO) */}
            {listaFechamentoFiltrada.length > 0 && (
              <div className="bg-slate-50 border-b border-slate-200 px-6 py-3 flex items-center gap-4 shrink-0">
                <button 
                  onClick={handleToggleModalSelectAll}
                  className="text-slate-400 hover:text-brand-primary transition-colors flex items-center gap-2"
                >
                  {isAllModalSelected ? <CheckSquare className="w-5 h-5 text-brand-primary" /> : <Square className="w-5 h-5" />}
                  <span className="text-sm font-semibold text-slate-600">Selecionar Todas</span>
                </button>
              </div>
            )}

            <div className="p-4 xl:p-6 overflow-y-auto flex-1 min-h-0 space-y-4 custom-scrollbar bg-slate-50/50">
              {listaFechamentoBruta.length === 0 ? (
                <div className="py-16 flex flex-col items-center justify-center text-center">
                  <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4">
                    <CheckCircle className="w-8 h-8 text-green-500" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-800">Tudo limpo por aqui!</h3>
                  <p className="text-slate-500 font-medium mt-1">Não há contratos pendentes de faturamento neste momento.</p>
                </div>
              ) : listaFechamentoFiltrada.length === 0 ? (
                <div className="py-12 flex flex-col items-center justify-center text-center opacity-70">
                  <Search className="w-10 h-10 text-slate-300 mb-3" />
                  <h3 className="text-base font-semibold text-slate-700">Nenhuma imobiliária encontrada</h3>
                  <p className="text-sm text-slate-500 mt-1">Tente buscar por outro nome.</p>
                </div>
              ) : (
                currentModalItems.map((imob) => {
                  const isSelected = selectedModalImobs.includes(imob.companyId);
                  
                  return (
                    <div key={imob.nome} className={`flex flex-col md:flex-row justify-between items-start md:items-center p-4 xl:p-5 bg-white border rounded-xl transition-colors shadow-sm gap-4 xl:gap-6 ${isSelected ? 'border-brand-primary ring-1 ring-brand-primary/20' : 'border-slate-200 hover:border-brand-primary/40'}`}>
                      
                      <div className="flex items-center gap-3 xl:gap-4 flex-1 min-w-0">
                        <button 
                          onClick={() => handleToggleModalSelect(imob.companyId)}
                          className="text-slate-400 hover:text-brand-primary transition-colors"
                        >
                          {isSelected ? <CheckSquare className="w-6 h-6 text-brand-primary" /> : <Square className="w-6 h-6" />}
                        </button>
                        
                        <div className="w-10 h-10 xl:w-12 xl:h-12 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0">
                          <Building2 className="w-5 h-5 text-slate-400" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <h4 className="font-bold text-slate-800 text-base truncate">{imob.nome}</h4>
                          <p className="text-xs xl:text-sm font-medium text-slate-500 mt-0.5">
                            {imob.count} contrato(s) pendente(s)
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-4 xl:gap-6 w-full md:w-auto justify-between md:justify-end border-t md:border-0 border-slate-100 pt-4 md:pt-0 shrink-0 ml-10 md:ml-0">
                        <div className="text-left md:text-right">
                          <p className="text-xs font-medium text-slate-500 mb-0.5">Total a Cobrar</p>
                          <p className="text-lg xl:text-xl font-bold text-slate-800">
                            R$ {imob.total.toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                          </p>
                        </div>

                        <button 
                          onClick={() => handleGerarBoletoImobiliaria(imob)}
                          disabled={isProcessingLote}
                          className="flex items-center justify-center gap-1.5 px-3 py-2 bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-800 rounded-lg transition-colors font-bold text-xs shadow-sm disabled:opacity-50 whitespace-nowrap"
                          title="Faturar individualmente"
                        >
                          Cobrar Só Esta
                        </button>
                      </div>

                    </div>
                  );
                })
              )}
            </div>

            {/* CONTROLES DE PAGINAÇÃO DO MODAL */}
            {listaFechamentoFiltrada.length > 0 && (
              <div className="px-4 py-3 xl:px-6 xl:py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between shrink-0">
                <span className="text-sm text-slate-500 font-medium">
                  Mostrando <span className="font-bold text-slate-800">{indexOfFirstModalItem + 1}</span> a <span className="font-bold text-slate-800">{Math.min(indexOfLastModalItem, listaFechamentoFiltrada.length)}</span> de <span className="font-bold text-slate-800">{listaFechamentoFiltrada.length}</span> imobiliárias
                </span>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={prevModalPage}
                    disabled={currentModalPage === 1}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                    {currentModalPage} / {totalModalPages || 1}
                  </span>
                  <button 
                    onClick={nextModalPage}
                    disabled={currentModalPage >= totalModalPages}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      , document.body)}

    </div>
  );
};

export default AdminGarantiasAtivasPage;